// extracted by mini-css-extract-plugin
module.exports = {"editImageContainer":"styles__editImageContainer___G3Mq0","uploadLink":"styles__uploadLink___3NCFr"};